import { Center, Spinner, Stack } from '@chakra-ui/react'

export const Loader = () => {
  return (
    <Center minH="100vh" bg="bg" px={4}>
      <Stack align="center" gap={4}>
        <Spinner color="primary.fg" size="lg" />
      </Stack>
    </Center>
  )
}
